import React from 'react'

import { Container } from './styles'

function Loading() {
  return (
    <Container>
      <h1>Loading</h1>
      <img
        src="https://media.giphy.com/media/sIIhZliB2McAo/giphy.gif"
        alt="Loading"
      />
    </Container>
  )
}

export default Loading
